import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import wsClient from "src/wsClient"
import { selectGameConfig } from "src/store/common"
import { selectGame, selectViewerId } from "src/store/game"
import { dischargeOrderedAt, dischargeSummary } from "src/utils/pendingOrders"
import { playerFacingError } from "src/utils/errorMessages"

import UnderConstruction from "src/components/UnderConstruction"

import "./RetiringNote.css"

/* "N retiring → +M 👷 next round", with the ✕ that takes the order back (owner, 2026-10-23,
   requirement 36 D5). A discharge is an order that lands when the round turns, and the bodies it
   names are already off the garrison the row and the sheet draw (`pendingOrders.effectiveForPlayer`),
   so this line is the only place they are still counted. One component for the roster row and the
   city sheet, so the two cannot word it differently. Renders nothing where the viewer has no order
   on the cell; an ally's order is not the viewer's to take back and is not listed. */
const RetiringNote = ({ city, className = "" }) => {
  const { t } = useTranslation()
  const game = useSelector(selectGame)
  const gameConfig = useSelector(selectGameConfig)
  const userId = useSelector(selectViewerId)
  if (!city || userId == null) return null
  const order = dischargeOrderedAt({ metadata: game?.metadata, userId, col: city.col, row: city.row })
  if (!order) return null
  const { bodies, workers } = dischargeSummary({ order, gameConfig })

  // The server refuses any order, a take-back included, from a player who has readied up.
  const isReady = Boolean(game?.players?.find((seat) => String(seat.user.id) === String(userId))?.ready)
  const readyReason = isReady ? playerFacingError("UserAlreadyReady") : null

  return (
    <div className={`retiring-note ${className}`.trim()} data-testid="retiring-note">
      <UnderConstruction decorative className="retiring-pick" />
      <span className="retiring-text">{t("city.retiring", { count: bodies, workers })}</span>
      <button
        type="button"
        className="retiring-cancel"
        data-action="cancel-discharge"
        disabled={Boolean(readyReason)}
        title={readyReason || t("city.cancelDischargeHint")}
        aria-label={t("city.cancelDischargeHint")}
        onClick={(event) => {
          event.stopPropagation()
          wsClient.send("game", { action: "cancel_discharge", column: Number(city.col), row: Number(city.row) })
        }}
      >
        ✕
      </button>
    </div>
  )
}

export default RetiringNote
